/* BONQUERÉ — AI transparency page anchor navigation (progressive enhancement). */
(function () {
  'use strict';

  var observers = new WeakMap();
  var resolvers = new WeakMap();

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function goTo(target, pushHash) {
    if (!target) return;

    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    if (pushHash && target.id && window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + target.id);
    }
  }

  function init(root) {
    if (!root) return;

    var previous = observers.get(root);
    if (previous) {
      previous.disconnect();
      observers.delete(root);
    }

    var nav = root.querySelector('[data-ai-nav]');
    var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-ai-link]')) : [];
    var headings = links
      .map(function (link) {
        return document.getElementById(link.getAttribute('data-ai-link'));
      })
      .filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        var isActive = link.getAttribute('data-ai-link') === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    links.forEach(function (link) {
      if (link.dataset.aiBound === 'true') return;
      link.dataset.aiBound = 'true';

      link.addEventListener('click', function (event) {
        var heading = document.getElementById(link.getAttribute('data-ai-link'));
        if (!heading) return;

        event.preventDefault();
        setActive(heading.id);
        goTo(heading, true);
      });
    });

    if (!('IntersectionObserver' in window) || !headings.length) return;

    function readingLine() {
      var value = parseFloat(getComputedStyle(headings[0]).scrollMarginTop);
      return isFinite(value) ? value : 96;
    }

    function resolveActive() {
      var line = readingLine() + 2;
      var current = null;

      for (var index = 0; index < headings.length; index += 1) {
        if (headings[index].getBoundingClientRect().top <= line) {
          current = headings[index];
        } else {
          break;
        }
      }

      setActive(current ? current.id : null);
    }

    var observer = new IntersectionObserver(resolveActive, {
      rootMargin: '-' + Math.round(readingLine()) + 'px 0px 0px 0px',
      threshold: 0
    });

    headings.forEach(function (heading) {
      observer.observe(heading);
    });

    observers.set(root, observer);
    resolvers.set(root, resolveActive);
    resolveActive();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ai-page]');
    Array.prototype.forEach.call(roots, init);
  }

  function honourHash() {
    if (window.location.hash.length < 2) return;

    var target = document.getElementById(window.location.hash.slice(1));
    var root = target ? target.closest('[data-ai-page]') : null;
    if (!target || !root) return;

    window.requestAnimationFrame(function () {
      goTo(target, false);
      var resolve = resolvers.get(root);
      if (resolve) resolve();
    });
  }

  initAll(document);
  honourHash();

  window.addEventListener('hashchange', honourHash);

  if ('onscrollend' in window) {
    window.addEventListener('scrollend', function () {
      var roots = document.querySelectorAll('[data-ai-page]');
      Array.prototype.forEach.call(roots, function (root) {
        var resolve = resolvers.get(root);
        if (resolve) resolve();
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    honourHash();
  });
})();
